import * as React from "react";
import type { SVGProps } from "react";
const SvgCouponIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="coupon_icon_svg__icon"
    viewBox="0 0 1066 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M149.333 213.333a64 64 0 0 0-64 64v128c0 37.12 29.227 59.563 54.272 65.28 22.059 5.078 35.712 22.998 35.712 41.387 0 18.39-13.653 36.31-35.712 41.387-25.045 5.674-54.272 28.16-54.272 65.28v128a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V597.419c0-23.638-19.2-42.752-42.752-42.752-28.416 0-47.402-21.248-47.402-42.667s18.986-42.667 47.36-42.667c23.68 0 42.794-19.114 42.794-42.752V277.333a64 64 0 0 0-64-64h-768zm21.334 177.494v-92.16h182.485v17.792a42.667 42.667 0 0 0 85.333 0v-17.792H896v92.16c-51.456 16.81-90.155 63.445-90.155 121.173S844.544 616.363 896 633.173v92.16H438.485v-17.792a42.667 42.667 0 1 0-85.333 0v17.792H170.667v-92.16C221.824 616.363 260.65 569.6 260.65 512s-38.827-104.363-89.984-121.173zm267.818 50.048a42.667 42.667 0 1 0-85.333 0v124.458a42.667 42.667 0 1 0 85.333 0V440.875z"
    />
  </svg>
);
export default SvgCouponIcon;
